export default "__VITE_ASSET__6db714cb__"